enum EVolumetricLayerType {
  Concentration,
  Volumetric,
}

export default EVolumetricLayerType;

export enum EVolumetricLayerTarget {
  Well,
  Drop,
}
